export const editGlobalThemeModal = {
  extends: '/add-global-theme-modal',
  ModalHeader: (el, s, ctx) => ({
    title: ctx.utils.toTitleCase(`${s.themeModifier?.slice(1)} Theme`),
    p: `Customise document ${s.themeModifier} theme`
  }),
  Preview: {},
  Flex_fields: {},
  Flex: {},
  ModalFooter: {
    CheckButton: {},
    'IconButton.trash': {
      icon: 'trash outline',
      onClick: async (ev, el, s) => {
        const { themeModifier } = s
        const theme = el.getDesignSystem('theme')
        const text = 'Do you want to remove the color?'
        if (themeModifier && window.confirm(text)) {
          delete theme.document[themeModifier]
          await el.updateDesignSystem({
            theme: {
              document: theme.document
            }
          })
          el.call('closeRouterModal', el, s)
        }
      },
    },
  },
  props: {
    onInit: (el, s) => {
      const theme = el.getDesignSystem('theme')
      if (!theme) {
        return
      }
      const docThemes = theme.document
      const themeModifier =
        s.key || window.location.pathname.split('global-theme/')[1]
      const value = docThemes[themeModifier]

      if (!value || !themeModifier) {
        return
      }
      s.update(
        {
          themeModifier,
          value
        },
        {
          preventUpdate: true,
          preventContentUpdate: true
        }
      )
    },
  },
};